import { FunctionComponent, useEffect, useRef } from 'react'

import { Transfer, TransferStatus, isParticularTransfer } from '../types'
import TransferReportTable from './transferReportTable'
import transfersCss from '../styles.module.scss'

export type PendingTab = 'particular' | 'convenios'

type TransferReportProps = {
  transfers: Transfer[]
  status: TransferStatus
  /** Attendance number search (controlled by the panel header). */
  search: string
  /** Particular vs. convênios, for pending titles (controlled by the panel header). */
  pendingTab: PendingTab
  /** Limits the table height; without it the table fills the available space. */
  maxHeight?: string
}

const matchesAtendimento = (term: string) => (transfer: Transfer) => {
  if (!term) {
    return true
  }

  return (
    transfer.numeroAtendimento !== null &&
    String(transfer.numeroAtendimento).includes(term)
  )
}

/** Detail table for the selected status. */
const TransferReport: FunctionComponent<TransferReportProps> = ({
  transfers,
  status,
  search,
  pendingTab,
  maxHeight,
}) => {
  const isPending = status === TransferStatus.PENDENTE
  const scrollRef = useRef<HTMLDivElement>(null)

  const filtered = transfers.filter(matchesAtendimento(search.trim()))
  const visible = isPending
    ? filtered.filter((t) =>
        pendingTab === 'particular' ? isParticularTransfer(t) : !isParticularTransfer(t)
      )
    : filtered

  // A new list starts from the top.
  useEffect(() => {
    scrollRef.current?.scrollTo({ top: 0 })
  }, [status, pendingTab, search])

  return (
    <div className={transfersCss.report}>
      <div ref={scrollRef} className={transfersCss.reportTable} style={{ maxHeight }}>
        <TransferReportTable
          transfers={visible}
          status={status}
          showGlosaStatus={isPending && pendingTab === 'convenios'}
          scrollRef={scrollRef}
        />
      </div>
    </div>
  )
}

export default TransferReport
